export const reviewArrayFieldStyles = {
	nestedGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5
	},

	flatListWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	},

	validRowsContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1.5
	}
};
